import React from 'react';
import { Flex, Message } from 'rebass';
import styled from 'styled-components';
import { space } from 'styled-system';

// const BaseMessage = Message.extend`
//   width: 100%
//   z-index: 999
// `;

const Box = styled.div`
  ${space}
`;

const ErrorMessage = Message.extend`
  background-color: ${props => props.theme.colors.red}
`;

const ErrorNotification = ({error, hideNotification}) => {
  return (
    <ErrorMessage>
      <Flex justifyContent='space-between'>
        <Box>ikoni*</Box>
        <Box>{error}</Box>
        <Box onClick={() => hideNotification()}>X*</Box>
      </Flex>
    </ErrorMessage>
  );
};

export default ErrorNotification;


// WEBPACK FOOTER //
// ./src/components/notification/ErrorNotification.jsx